import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function ConsentLoadingStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "consent-loading-heading", "aria-busy": "true", children: [_jsx("h3", { id: "consent-loading-heading", children: t('consent.loading.heading') }), _jsx("p", { role: "status", children: t('consent.loading.status') })] }));
}
//# sourceMappingURL=loading-step.js.map